import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { API_ENDPOINTS } from '../config/api';

const FeePaymentCallback = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [message, setMessage] = useState('Verifying your Flutterwave payment...');
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const transactionId = params.get('transaction_id');
    const txRef = params.get('tx_ref');
    const status = params.get('status');
    if (status !== 'successful' || !transactionId || !txRef) {
      setMessage('The payment was not completed. No paid fee was recorded.');
      return;
    }
    fetch(`${API_ENDPOINTS.BASE_URL}/api/fees/flutterwave/verify`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ transactionId, txRef })
    })
      .then(async response => {
        const data = await response.json();
        if (!response.ok) throw new Error(data.error || 'Payment verification failed');
        setSuccess(true);
        setMessage('Payment verified successfully. Your fee balance has been updated.');
      })
      .catch(error => setMessage(error.message));
  }, [params]);

  return (
    <div className="min-h-screen bg-slate-950 grid place-items-center p-5">
      <div className="bg-white rounded-lg p-8 max-w-lg w-full text-center shadow-2xl">
        <div className={`w-16 h-16 rounded-full mx-auto grid place-items-center font-black ${success ? 'bg-emerald-100 text-emerald-700' : 'bg-amber-100 text-amber-800'}`}>
          {success ? 'OK' : '...'}
        </div>
        <h1 className="text-2xl font-black text-slate-900 mt-5">School Fee Payment</h1>
        <p className="text-slate-600 mt-3">{message}</p>
        <button onClick={() => navigate('/parent/dashboard', { replace: true })} className="mt-6 bg-emerald-700 text-white px-6 py-3 rounded-lg font-black">Return to Parent Dashboard</button>
      </div>
    </div>
  );
};

export default FeePaymentCallback;
